const Territory = require('../../entities/Territory');
const { Age }  = require("../Constants");
const TerritoryNames = require("../Names/TerritoryNames");

class StrategicTerritory extends Territory {
    constructor(age){
        super(
            age,
            TerritoryNames.StrategicTerritory,
            "Draw " + StrategicTerritory.GetCardCount(age) + " military cards and gain " + StrategicTerritory.GetMilitaryCount(age) + " military.",
            {}
        )
    }

    static GetCardCount(age)
    {
        switch (age)
        {
            default:
                return null;
            case Age.Age1:
                return 3;
            case Age.Age2:
                return 5;
        }
    }

    static GetMilitaryCount(age)
    {
        switch (age)
        {
            default:
                return null;
            case Age.Age1:
                return 2;
            case Age.Age2:
                return 4;
        }
    }
}

module.exports = StrategicTerritory;